var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"box",staticStyle:{"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%, -50%)"}},[_c('VueQr',{attrs:{"draggable":"false","correctLevel":3,"dotScale":1,"margin":15,"size":256,"text":_vm.qrCode}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7294d8c1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supplier-qr.vue
// module id = null
// module chunks = 